import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.footer-content > *, .footer-social-icon, .footer-link {
  animation: none !important;
  transition: none !important;
  transform: none !important;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <footer className="footer-primary">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-branding">
              <div className="footer-logo-wrapper">
                <span className="footer-logo-text">Bajwa Co</span>
                <span className="footer-logo-sub">Creator Management</span>
              </div>
              <p className="section-content footer-description">
                {' '}
                Friendly, authentic, and results-driven management for modern
                creators. I handle the business so you can stay in your creative
                flow.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
            <nav aria-label="Footer Navigation" className="footer-nav">
              <ul className="footer-links-list">
                <li>
                  <a href="#home">
                    <div className="footer-thq-footer-link-elm footer-link">
                      <span>Back To Top</span>
                    </div>
                  </a>
                </li>
                <li></li>
                <li></li>
              </ul>
            </nav>
          </div>
          <div className="footer-bottom">
            <div className="footer-legal">
              <span className="footer-copyright">
                © 2026 Bajwa Co. All rights reserved.
              </span>
              <div className="footer-legal-links">
                <a href="privacy-policy" target="_blank" rel="noreferrer noopener">
                  <div className="footer-legal-link">
                    <span>Privacy Policy</span>
                  </div>
                </a>
                <a href="terms-of-service" target="_blank" rel="noreferrer noopener">
                  <div className="footer-legal-link">
                    <span>Terms of Service</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container4">
        <div className="footer-container5">
          <Script
            html={`<style>
        @keyframes footerFadeIn {from {opacity: 0;
transform: translateY(20px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="footer-container6">
        <div className="footer-container7">
          <Script
            html={`<script defer data-name="footer-interaction">
(function(){
  // Simple intersection observer to trigger a subtle animation when footer enters view
  const footerSection = document.querySelector('.footer-primary');
  
  const footerObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const children = entry.target.querySelectorAll('.footer-content > *, .footer-bottom');
        children.forEach((child, index) => {
          child.style.animationDelay = \`\${index * 0.1}s\`;
        });
        footerObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  if (footerSection) {
    footerObserver.observe(footerSection);
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
